import React from "react";
import { TextField } from "@mui/material";

export const ControlPanelTextField = ({
  valueAction,
  target,
  handleChange,
  label,
  type,
  hexToRgb
}) => {
  return (
    <TextField
      size="small"
      type={type}
      label={label}
      value={valueAction}
      onChange={(e) => handleChange(target, hexToRgb ? hexToRgb(e.target.value) : e.target.value)}
      fullWidth
    />
  );
};
